// extracted by mini-css-extract-plugin
module.exports = {"dashboardCardList":"DashboardCardList_dashboardCardList__1bE4B","dashboardCard":"DashboardCardList_dashboardCard__3VGJl"};